import canUse from './canUse'
import Cookie from 'js-cookie'

const HasToken = (token) => {
    if (canUse()) {
        return !!Cookie.get('mss_token', token)
    }
    return false
}

export default HasToken
